import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import {Provider} from 'react-redux'
import store from './store'
import {BrowserRouter as Router} from 'react-router-dom'

ReactDOM.render(
  <Provider store={store}> 
    <Router basename={'/pizza-configurator'}>
      <App />
    </Router>
  </Provider>, 
  document.getElementById('root'));
  registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js